module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/tee-73aabf55baccef60b06754bd83203e33.png";